import Navbar from './components/header';
// import Srtbtns from './components/SrtBtns'; 
// import Body from './components/body';
function App() {
  return (
    <>
    <Navbar />
    </>
  );
}

export default App;
